import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { StudentDetailsParents } from "../components/StudentDetailsParents";
import { Box, Metadata, useTranslations } from "@bsm/component";
import { useMemo } from "react";
import _ from "lodash";

export const StudentHealthAndAllergiesContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const value = useMemo(() => data?.healthAndAllergy, [data])
    const [
        HEALTH_AND_IMMUNISATION,
        FOOD_ALLERGY_DETAILS,
        REGULAR_MEDICATIONS,
        MEDICINE,
        DOSAGE,
        SWEET_TREAT_REWARD,
        REWARD_ALTERNATIVE,
    ] = useTranslations(i18nKeys)
    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={HEALTH_AND_IMMUNISATION} className="flex flex-col gap-3 p-10">
                <Metadata label={FOOD_ALLERGY_DETAILS} value={!_.isEmpty(value?.foodAllergyDetails) ? value?.foodAllergyDetails : 'None'} />
                <h3>{REGULAR_MEDICATIONS}</h3>
                {
                    value?.regularMedication?.map((medication) => {
                        return (
                            <div className="flex flex-col mb-2 gap-3">
                                <Metadata label={MEDICINE} value={medication?.medecine} />
                                <Metadata label={DOSAGE} value={medication?.dosage} />
                            </div>
                        )
                    })
                }
                <Metadata label={SWEET_TREAT_REWARD} value={value?.sweetTreatsReward ? 'Yes' : 'No'} />
                { 
                    !value?.sweetTreatsReward && <Metadata label={REWARD_ALTERNATIVE} value={value?.rewardAlternative} /> 
                }
            </Box>
        </div>
    );
}
const i18nKeys = [
    "std_health_and_immunisation",
    "std_food_allergy_details",
    "std_regular_medications",
    "std_medecine",
    "std_dosage",
    "std_sweet_treat_reward",
    "std_reward_alternative",
]
